import PropTypes from 'prop-types';

const LocationIcon = ({ width = '20', height = '28' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2403_61706)">
      <path
        d="M7.54425 18.48C7.44645 18.6267 7.28178 18.7148 7.10547 18.7148C6.92916 18.7148 6.76449 18.6267 6.66668 18.48C5.41867 16.608 3.58046 14.2961 2.2995 11.9448C1.27526 10.0648 0.777344 8.46138 0.777344 7.04297C0.777344 3.55364 3.61614 0.714844 7.10547 0.714844C10.5948 0.714844 13.4336 3.55364 13.4336 7.04297C13.4336 8.46138 12.9357 10.0648 11.9114 11.9448C10.6314 14.2943 8.7897 16.6119 7.54425 18.48ZM7.10547 1.76953C4.1977 1.76953 1.83203 4.1352 1.83203 7.04297C1.83203 8.28061 2.2879 9.71899 3.22566 11.4403C4.32981 13.467 5.90545 15.5229 7.10547 17.2513C8.30532 15.5231 9.88105 13.4671 10.9853 11.4403C11.923 9.71899 12.3789 8.28061 12.3789 7.04297C12.3789 4.1352 10.0132 1.76953 7.10547 1.76953Z"
        fill="#666666"
      />
      <path
        d="M7.10547 10.207C5.3608 10.207 3.94141 8.78763 3.94141 7.04297C3.94141 5.2983 5.3608 3.87891 7.10547 3.87891C8.85013 3.87891 10.2695 5.2983 10.2695 7.04297C10.2695 8.78763 8.85013 10.207 7.10547 10.207ZM7.10547 4.93359C5.94236 4.93359 4.99609 5.87986 4.99609 7.04297C4.99609 8.20608 5.94236 9.15234 7.10547 9.15234C8.26858 9.15234 9.21484 8.20608 9.21484 7.04297C9.21484 5.87986 8.26858 4.93359 7.10547 4.93359Z"
        fill="#666666"
      />
    </g>
    <defs>
      <clipPath id="clip0_2403_61706">
        <rect
          width="15.1579"
          height="18"
          fill="white"
          transform="matrix(-1 0 0 1 15.1582 0.714844)"
        />
      </clipPath>
    </defs>
  </svg>
);

LocationIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default LocationIcon;
